import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Layout } from '../components/Layout/Layout';
import { RcQuotesStyles } from './BackOfficeVehicleQuotes.styles';
import {
  addBackOfficeQuoteToCart, loadBackOfficeQuotes, removeBackOfficeQuoteFromCart, resetBackOfficeQuotes,
} from '../../../features/backofficeResults/backofficeResultsActions';
import PageLoading from '../../../common/componentsV2/elements/PageLoading';
import { confirmAlert } from '../../../common/utils/alerts';
import { RiskContainer } from '../../HouseProduct/styles/HomeResultPage.styles';
import SaluteModalButtons from '../../SaluteProduct/components/SaluteModalButtons';
import SaluteModal from '../../SaluteProduct/components/SaluteModal';
import { getQuoteTypes } from '../../../features/utilities/utilitiesActions';
import { V2FontImport } from '../../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import SaluteSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/SaluteSummaryCard';
import QuoteCostSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';
import FailedQuotationsComponent from '../../../common/components/redesignComponents/ResultPageComponents/v2/FailedQuotationsComponent';

function BackOfficeSaluteQuotes() {
  const { requestToken } = useParams();
  const state = useSelector((store) => store.backofficeResults.back_office_quotes);
  const {
    loading,
    requestInfo,
    quotes,
    failedQuotes,
    processingQuote,
    addingQuote,
    customer,
    // toSelect,
    risk_quotations,
    quote_id_to_add,
  } = state;
  // const modifyData = () => {
  //   navigate(`/backoffice/quote/${requestToken}/tutela-legale`);
  // };
  const [openModal, setOpenModal] = useState(false);

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  useEffect(() => {
    loadBackOfficeQuotes(requestToken);
    getQuoteTypes();

    return () => {
      resetBackOfficeQuotes();
    };
  }, []);
  const [, setShowModal] = useState(false);

  const refresh = () => loadBackOfficeQuotes(requestToken);

  if (loading) {
    return <PageLoading />;
  }

  const fetchQuotes = () => {
    loadBackOfficeQuotes(requestToken);
  };

  const selectQuotation = (quoteId, closeButton) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addBackOfficeQuoteToCart(quoteId, fetchQuotes, closeButton, setShowModal, quote_id_to_add));
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeBackOfficeQuoteFromCart(quoteId, fetchQuotes));
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (risk_quotations && risk_quotations[type.id] !== undefined) {
        for (let i = 0; i < risk_quotations[type.id].length; i++) {
          const item = risk_quotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return (quoteInProccessAmount + risksTotalAmount).toFixed(2);
  };
  return (
    <Layout>
      <V2FontImport />
      <RcQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <SaluteSummaryCard customer={customer} insuranceRequest={requestInfo} />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={risk_quotations}
              getTotal={getTotal}
              rcTypeLabel={processingQuote?.product_name}
            />
          </ResultOverviewRow>
          {/* {showModal && (
          <CustomModalSalute show={showModal} onClose={() => setShowModal(false)} title="Seleziona una di questa quotaziona prima!">
            {toSelect.map((tp, index) => (
              <React.Fragment key={index}>
                {addingQuote && <PageLoading />}
                {addingQuote === false && quotes[tp]
                  ? quotes[tp].map((quote, index) => (
                    <div className="mt-3" key={index}>
                      <SaluteCard requestInfo={requestInfo} quote={quote} selectQuotation={selectQuotation} />
                    </div>
                  ))
                  : addingQuote === false && (
                  <p>Nessuna Quotazione Trovata.</p>
                  )}
              </React.Fragment>
            ))}
          </CustomModalSalute>
        )} */}
          <RiskContainer className="mb-3 pb-3 result-home-third-step">
            {quoteTypes.map((type, index) => (
              <React.Fragment key={index}>
                {quotes && quotes[type.id] && (
                  <SaluteModalButtons
                    insuranceRequest={requestInfo}
                    processingQuote={processingQuote}
                    type={type}
                    removeItemFromCart={removeItemFromCart}
                    riskQuotations={risk_quotations}
                  />
                )}
              </React.Fragment>
            ))}
          </RiskContainer>
          {quoteTypes.map((type, index) => (
            <SaluteModal
              insuranceRequest={requestInfo}
              type={type}
              key={index}
              addingQuote={addingQuote}
              quotations={quotes}
              setOpenModal={setOpenModal}
              openModal={openModal}
              requestToken={requestToken}
              refresh={refresh}
              selectQuotation={selectQuotation}
            />
          ))}
          {failedQuotes !== null && failedQuotes?.length > 0 && (
            <FailedQuotationsComponent failedQuotes={failedQuotes} />
          )}
        </div>
      </RcQuotesStyles>
    </Layout>
  );
}

export default BackOfficeSaluteQuotes;
